import { render } from "./FullLinesField6.vue?vue&type=template&id=45754fe9"
import script from "./FullLinesField6.vue?vue&type=script&lang=js"
export * from "./FullLinesField6.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__